webix.protoUI({
	name:"filelist"
}, webix.EditAbility, webix.ui.list);